import { render, staticRenderFns } from "./Evento_liga_prematch2.vue?vue&type=template&id=3a809213&scoped=true"
import script from "./Evento_liga_prematch2.vue?vue&type=script&lang=js"
export * from "./Evento_liga_prematch2.vue?vue&type=script&lang=js"
import style0 from "./Evento_liga_prematch2.vue?vue&type=style&index=0&id=3a809213&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a809213",
  null
  
)

export default component.exports